import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../context';
import { showAppCreationButton } from '../../utils';

export default function WelcomeBanner() {
  const { env, user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate({
      pathname: user.hasApps ? '/apps' : '/app/new',
      state: { from: location.pathname },
    });
  };

  return (
    <Card className="banner flex-fill mb-5">
      <Card.Body as={Row} className="p-4 d-flex flex-column align-items-center">
        <h1 className="mb-3 py-3 text-center">{t('welcome.title')}</h1>
        <p className="text-lg text-info mb-3 text-center">{t('welcome.description')}</p>
        {!user.confirmed_at && (
          <p className="text-lg text-info mb-3 text-center">
            {t('applications.empty.messages.notConfirmed')}
          </p>
        )}
        <div className="d-flex flex-column align-items-center justify-content-center flex-sm-row pb-3">
          <Button
            onClick={handleClick}
            className="text-sm text-uppercase m-1 mx-sm-3"
            disabled={!user.confirmed_at || (!user.hasApps && !showAppCreationButton(env))}
          >
            {t(`welcome.banner.button.${user.hasApps ? 'hasApps' : 'noApps'}`)}
          </Button>
          <Button
            onClick={() => navigate('/settings/members')}
            className="text-sm text-uppercase m-1 mx-sm-3"
          >
            {t(`welcome.banner.button.team`)}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
